"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getPathname = _interopRequireDefault(require("crm_internal/utils/getPathname"));

var getFragmentBy = function getFragmentBy(root, href) {
  if (href === root) {
    return '/';
  }

  return href.split(root)[1];
};

var getFragment = function getFragment(href) {
  return getFragmentBy((0, _getPathname.default)(), href);
};

var isInRootBy = function isInRootBy(root, href) {
  return href.indexOf(root) === 0;
};

var isInRoot = function isInRoot(href) {
  return isInRootBy((0, _getPathname.default)(), href);
};

var _default = {
  getFragment: getFragment,
  getFragmentBy: getFragmentBy,
  isInRoot: isInRoot,
  isInRootBy: isInRootBy
};
exports.default = _default;
module.exports = exports.default;